<script lang="ts">
    import { vehiclesService } from "../services";
    import AppWraper from "../components/AppWraper.svelte";
    import { v4 as v4uuid } from 'uuid';
    import { navigate } from "svelte-navigator";
    import { Vehicle } from "../Model/Vehicle";
    import VehicleData from "../components/VehicleData.svelte";
    import { Button, TabContent, TabPane } from "sveltestrap";
    import { error, success } from "../../public/my-theme";

    export let vehicleId: string;

    let vehicle: Vehicle;

    let vehicleDataForm: VehicleData; 

    $: loadVehicle(vehicleId);

    async function loadVehicle(vehicleId: string): Promise<void> {
        if (vehicleId != 'new') {
            vehicle = await vehiclesService.findOne(vehicleId);
            return;
        }

        vehicle = new Vehicle({
            id:  v4uuid(),
            thirdId: new URLSearchParams(window.location.search).get('third'),
            plate: '',
            vehicleType: '',
            markId: null,
            modelId: null,
            frame: '',
            insuranceCarrierId: null,
            policyNumber: '',
            validityPolicy: '',
            validityInpeccion: '',
            colorId: null,
            plateDate: '',
            transportCardType: null,
            transportCardTypeVisible: false,
            transportCardTypeCorresponding: false,
            observations: ''
        }).getState();
    }

    async function saveVehicle(){
        const res = await Promise.all([
            vehicleDataForm.saveVehicleData()
        ])

        if(res.includes(undefined)) {
            navigate('/vehiculo/' + vehicle.id);
            success('Se han realizado los cambios correctamente.');
        } else {
            error('Error al realizar los cambios.');
            throw new Error('Error al realizar los cambios.');
        }
    }

</script>

<style>

</style>

<AppWraper>
    {#if vehicle}
        <div class="container-fluid p-5">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-9 mb-3">
                        <div class="text-start">
                            <h3>Ficha de  {vehicle.plate} </h3>
                        </div>
                    </div>
                <div class="col-12 col-sm-3 mb-3">
                    <div class="text-end">
                        <Button color="success" on:click={() => saveVehicle()}>
                            Guardar
                        </Button>
                    </div>
                </div>
                </div>

                <TabContent>
                    <TabPane tabId="dataVehicle" tab="Datos" active>
                        <div class="mt-3">
                            <VehicleData bind:this={vehicleDataForm} bind:vehicleData={vehicle} />
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    {/if}



</AppWraper>



